<template>
	<ui-modal
		:name="$mx_getModalName"
		:load-success="loader.modalSuccess"
		:load="loader.modal"
		:load-fail="loader.loadFail"
		:title="titleModal"
		icon="fal fa-user-cog"
		size="xxs"
		@close="cancel"
	>
		<div class="modal-content">
			<div class="stage-and-status-area">
				<ui-select-2
					v-model="form.funnel_stage_status_id"
					label="Status:"
					:data="options.status"
					:loading="loader.status"
					:disabled="disabledSatus"
					:show-footer="false"
					item-label="name"
					return-value="id"
				/>
			</div>
		</div>

		<template #footer>
			<div class="cancel-buttons">
				<ui-modal-cancel-button :modalName="$mx_getModalName" @close="cancel"
					>Cancelar</ui-modal-cancel-button
				>
			</div>
			<ui-button
				:disabled="!canSubmit"
				type="button"
				design="md success mw-100"
				@click="submit"
				>Salvar</ui-button
			>
		</template>
	</ui-modal>
</template>

<script>
	import { mapGetters } from 'vuex'

	import { uiButton } from '@/components/ui/buttons'
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSelect2 } from '@/components/ui/form'

	import {
		helpersMixin,
		loaderMixin,
		alertMixin,
		modalMixin,
		permissionsMixin,
		utilMixin,
	} from '@/mixins'

	const defaultForm = () => ({
		id: null,
		funnel_stage_id: null,
		funnel_stage_status_id: null,
		column: null,
		name: null
	})

	const defaultOptions = () => ({
		stage: [],
		status: [],
	})

	const defaultLoader = () => ({
		modal: false,
		modalSuccess: false,
		loadFail: false,
		stage: false,
		status: false,
	})

	export default {
		components: {
			uiModal,
			uiModalCancelButton,
			uiSelect2,
			uiButton,
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, modalMixin, permissionsMixin, utilMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},
		
		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				options: { ...defaultOptions() },
				setLoad: true
			}
		},

		mounted() {
			this.$root.$on('close-modal-animation', (val) => {
				if(!val) 
					this.$mx_setLoader('loadFail', true)
					setTimeout(() => {
						this.$mx_closeModal()
						this.$mx_reloadTablePage()
					}, 900)
			})

			this.$root.$on('modal-open-' + this.$mx_getModalName, async (payload) => {
				this.reset()
				
				this.setLoad = payload.load

				this.$mx_setLoaderList(['stage', 'status'], true)

				this.options.status = payload.status
				this.form.name = payload.name
				this.form.id = payload.id
				this.form.funnel_stage_id = payload.stage
				this.form.column = payload.column
				this.form.replick = payload.replick
				this.form.element = { ...payload.element }
				this.form.funnel_stage_status_id = payload.status[0].id

				this.$mx_setLoaderList(['stage', 'status'], false)
			})
		},

		beforeDestroy() {
			this.$mx_closeModal()
			this.$root.$off('close-modal-animation')
			this.$root.$off('modal-open-' + this.$mx_getModalName)
		},

		computed: {
			...mapGetters('auth', { user: 'getUser' }),

			titleModal() {
				return 'Selecione o status de ' + this.form.name
			},

			disabledSatus() {
				return this.options.status.length == 0
			},

			hasLoading() {
				return this.loader.status
			},

			hasStatus() {
				return (
					this.options.status.length > 0 &&
					this.$mx_hasValue(this.form.funnel_stage_status_id)
				)
			},

			notHasStatus() {
				return (
					this.options.status.length == 0 &&
					!this.$mx_hasValue(this.form.funnel_stage_status_id)
				)
			},

			allowFill() {
				return this.$mx_hasValue(parseInt(this.form.allow_fill))
			},

			canSubmit() {
				return (
					!this.hasLoading &&
					(this.hasStatus || this.notHasStatus)
				)
			},
		},

		methods: {

			/**
			 * Reset dos campos do formulário.
			 */
			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
			},

			closeAnimation() {
				setTimeout(() => {
					this.$mx_setLoader('modalSuccess', true)

					setTimeout(() => {
						this.$mx_closeModal()
						this.$mx_reloadTablePage()
					}, 1000)
				}, 500)
			},
			cancel () {
				this.$root.$emit('cancel-move-' + this.$mx_getModalName, this.form)
			},
			async submit() {
				if (!this.canSubmit) return
				if (this.setLoad == true) this.$mx_setLoader('modal', true)
				else this.$mx_closeModal()

				try {
					this.$root.$emit('modal-result-' + this.$mx_getModalName, this.form)
					// ...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.$mx_setLoader('modal', false)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
